import styled, { css } from 'styled-components';
import { Row,Col } from 'antd';


export const TimeLineAccordionHeading = styled.div`
  height: auto;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h3};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h3};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin-left: 50px;
  margin-top: 50px;
  margin-right: 50px;
  @media only screen and (max-width: 767px) {
    margin-left: 20px;
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.h4};
  }
  @media only screen and (max-width: 480px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;

export const HorizontalLine = styled.div`
  height: 1px;
  border: solid 1px #d4d4d4;
  margin-top: 49.5px;
  margin-left: 50px;
  margin-right: 50px;
  @media only screen and (max-width: 767px) {
    height: 1px;
    border: solid 1px #d4d4d4;
    margin-top: 39px;
    margin-left: 20px;
    margin-right: 20px
  }
`;

export const AccordionRows = styled(Row)`
margin-top: 76px;
`

export const FocusDiv = styled.div`
  marginTop: 9px;
  height: 21px;
  &&.focusExpanded:hover {
    cursor: default !important;
  }
  &&.focusCollapsed:hover {
    cursor: pointer !important;
  }
`;

export const StepCountWrapper = styled(Col)`
  width: 66px;
  height: 66px;
  border-radius: 33px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 5px #d4d4d4;
  background-color: ${props => props.theme.backgroundColor.tealBlue};
  position: absolute;
  z-index: 1;
  top:-31px;
  left: calc(50% - 27px);
`;

export const StepsCount = styled.div`
  width: 17px;
  height: 36px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: 30px;
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.colors.white};
  margin-top: 8px;
  margin-left: 19px;
  @media only screen and (max-width: 767px) {
    height: 28px;
    font-size: ${props => props.theme.fontSize.h4};
    margin-top: 3px;
    margin-left: 11px;
  } 
`;

export const HowItWorksStepWrapper = styled.div`
  height:auto;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px #eaeaea;
  background-color: ${props => props.theme.backgroundColor.layoutLight};
  position: relative;
  padding-bottom: 0px;
  @media only screen and (min-width:768px) and (max-width: 1375px) {
    && .howitWorksStepsImage {
      width: calc(100% - 157px);
    }
  }
  @media only screen and (min-width:768px) and (max-width: 1024px) {
    && .howitWorksStepsImage {
      width: calc(100% - 88px);
    }
  }
`;

export const AccordionWrapper = styled.div`
  width: 100%;
  @media only screen and (min-width: 768px) {
    cursor: pointer;
  }
`;

export const StepsTitle = styled.div`
  height: 30px;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color:${props => props.theme.backgroundColor.tealBlue};
  margin-left: 50px;
  margin-top: 40px;
`;

export const StepsMainHead = styled.div`
  height: auto;
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h2};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h2};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin-left: 50px;
  margin-top: 15px;
  `;